export const selectedClimateDataSourceIndex = "climatedatasource";
export const selectedCountryIndex = "country";
export const selectedRegionIndex = "region";
